'use client'
import * as createjs from 'createjs-module'

export class DropShadowFactory {
  public static create(n: createjs.DisplayObject, alpha: number = 0.4) {
    // n.shadow = new createjs.Shadow(`rgba(0,0,0,${alpha.toFixed(1)})`, 6, 6, 6)
  }
}
